import React, {
  createContext,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
  useMemo,
} from "react";
import { WithChildren } from "helpers";
import {
  getAllUser,
  getRolePrivilege,
  getUserRole,
} from "services/userManagementAPIs";
import { UserDetails } from "helpers/models/userManagemnt";
import { SelectionOption } from "helpers/models/auth_models";

interface UserManagementContextType {
  allUsers: UserDetails[];
  setAllUsers: Dispatch<SetStateAction<UserDetails[]>>;
  fetchAllUserHandler: () => void;
  fetchUserRoleHandler: () => void;
  fetchPrivilegeHandler: () => void;
  setUserRole: Dispatch<SetStateAction<any[]>>;
  userRole: any[];
  product: SelectionOption[];
  privileges: any[];
  setPrivileges: Dispatch<SetStateAction<any[]>>;
}

export const UserManagementContext = createContext<UserManagementContextType>({
  allUsers: [],
  setAllUsers: () => {},
  fetchAllUserHandler: () => {},
  fetchUserRoleHandler: () => {},
  fetchPrivilegeHandler: () => {},
  userRole: [],
  setUserRole: () => {},
  product: [],
  privileges: [],
  setPrivileges: () => {},
});

export const useUserManagementContext = () => {
  return useContext(UserManagementContext);
};

export const UserManagementProvider: React.FC<WithChildren> = ({
  children,
}) => {
  // ----useStates----
  const [allUsers, setAllUsers] = useState<UserDetails[]>([]);

  const [userRole, setUserRole] = useState<any[]>([]);
  const [product, setProduct] = useState<SelectionOption[]>([]);
  const [privileges, setPrivileges] = useState<any[]>([]);
  // ----Get API call----
  const fetchAllUserHandler = async () => {
    getAllUser()
      .then((response: any) => {
        setAllUsers(response.data.data);
      })
      .catch((error) => console.error(error));
  };

  const fetchUserRoleHandler = async () => {
    getUserRole()
      .then((response: any) => {
        setUserRole(response.data.data);

        const preFormateUserRole = response.data.data.map(
          (filteredItem: any) => ({
            label: filteredItem.productType.displayName,
            value: filteredItem.productType.guid,
          })
        );

        const removeDuplicateProduct = preFormateUserRole.filter(
          (item: { value: string }, index: number, self: any[]) =>
            index === self.findIndex((t) => t.value === item.value)
        );
        setProduct(removeDuplicateProduct);
      })
      .catch((error) => console.error(error));
  };

  const fetchPrivilegeHandler = async () => {
    if (privileges.length <= 0) {
      getRolePrivilege().then((response: any) => {
        setPrivileges(response.data.data);
      });
    }
  };
  const contextValue = useMemo(
    () => ({
      allUsers,
      setAllUsers,
      fetchAllUserHandler,
      fetchUserRoleHandler,
      userRole,
      setUserRole,
      product,
      privileges,
      setPrivileges,
      fetchPrivilegeHandler,
    }),
    // eslint-disable-next-line
    [
      allUsers,
      setAllUsers,
      userRole,
      setUserRole,
      product,
      privileges,
      setPrivileges,
    ]
  );
  return (
    <UserManagementContext.Provider value={contextValue}>
      {children}
    </UserManagementContext.Provider>
  );
};
